import API from "../api";
import { TokenService } from "@/api/storage";
import { initialize } from "@/api";
import {
  UserToken,
  PayloadAuth,
  PayloadOnboarding,
  PayloadLogin,
  PayloadEmail,
} from "../types";
import { Commit, Dispatch } from "vuex";
import {
  PayloadInvalidateToken,
  PayloadSuccessCaseExternal,
  PayloadSubmitSuccessCaseExternal,
} from "@/types";
export default {
  namespaced: true,
  state: {
    loginUser: {
      email: "",
      senha: "",
    },
  },
  mutations: {
    setLoginUser(state: any, payload: PayloadLogin) {
      state.loginUser = payload;
    },
  },
  actions: {
    storeToken({ dispatch }: { dispatch: Dispatch }, payload: UserToken): void {
      // PASSO 1: Salvar tokens antigos para invalidação posterior
      const oldTokens: PayloadInvalidateToken = {
        jwtToken: TokenService.getToken(),
        refreshToken: TokenService.getRefreshToken(),
      };

      // PASSO 2: Salvar NOVOS tokens IMEDIATAMENTE (operação atômica)
      // Isso garante que mesmo se a aba fechar, os novos tokens já estão salvos
      TokenService.saveToken(JSON.stringify(payload.token));
      if (payload.refreshToken) {
        TokenService.saveRefreshToken(JSON.stringify(payload.refreshToken));
      }

      // PASSO 3: Reinicializar axios com novos tokens IMEDIATAMENTE
      // Isso garante que outras requisições já usem os novos tokens
      initialize();

      // PASSO 4: Invalidar tokens antigos de forma ASSÍNCRONA (best-effort)
      // Se a aba fechar aqui, não há problema:
      // - Novos tokens já estão salvos e funcionando
      // - Tokens antigos ainda válidos no backend (não é problema crítico)
      // - Backend pode ter política de expiração automática
      if (oldTokens.jwtToken && oldTokens.refreshToken) {
        // Usar setTimeout para garantir que é assíncrono e não bloqueia
        setTimeout(() => {
          dispatch("requestInvalidateToken", oldTokens).catch((error: any) => {
            // Ignora erros de invalidação - tokens antigos já foram substituídos
            // Backend pode ter política de expiração automática de tokens não usados
            console.warn(
              "[STORE] Erro ao invalidar tokens antigos (ignorado):",
              error?.response?.status || error.message
            );
          });
        }, 0);
      }
    },
    storeTokenUrl(context: any, payload: string): void {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.saveToken(JSON.stringify(payload));
      initialize();
    },
    async requestLoginAuth(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadAuth
    ): Promise<UserToken> {
      const { data } = await API.getToken(payload);
      dispatch("storeToken", data);
      return data;
    },
    async requestLogin(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadOnboarding
    ): Promise<UserToken> {
      const { data } = await API.getTokenUser(payload);
      dispatch("storeToken", data);
      return data;
    },
    initializeAxios(): void {
      initialize();
    },
    async requestAuth(
      { dispatch }: { dispatch: Dispatch },
      payload: PayloadLogin
    ): Promise<UserToken> {
      const { data } = await API.getLogin(payload);
      dispatch("storeToken", data);
      dispatch("updateLogin", payload);
      return data;
    },
    async requestRecoverPassword(
      context: any,
      payload: PayloadEmail
    ): Promise<any> {
      const { data } = await API.postRecoverPassword(payload);
      return data;
    },
    updateLogin({ commit }: { commit: Commit }, payload: PayloadLogin): any {
      commit("setLoginUser", payload);
    },
    async requestNewToken({
      dispatch,
    }: {
      dispatch: Dispatch;
    }): Promise<UserToken> {
      const refreshToken = String(TokenService.getRefreshToken());
      const payload = {
        refreshToken: refreshToken,
      };
      const { data } = await API.patchNewTokenUser(payload);
      dispatch("storeToken", data);
      return data;
    },
    async requestInvalidateToken(
      context: any,
      payload: PayloadInvalidateToken
    ): Promise<any> {
      const { data } = await API.patchInvalidateToken(payload);
      return data;
    },
    async requestLogout(
      { dispatch }: { dispatch: Dispatch },
      payload = true
    ): Promise<void> {
      if (payload) {
        const payloadInvalidateToken: PayloadInvalidateToken = {
          jwtToken: TokenService.getToken(),
          refreshToken: TokenService.getRefreshToken(),
        };
        await dispatch("requestInvalidateToken", payloadInvalidateToken);
      }
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.removeFirstAccess();
      TokenService.removeIsAcceptTerm();
      TokenService.removeRole();
    },
    async requestSuccessCaseExternal(
      context: any,
      payload: PayloadSuccessCaseExternal
    ): Promise<any> {
      const { data } = await API.getSuccessCaseExternal(payload);
      return data;
    },
    async requestSubmitSuccessCaseExternal(
      context: any,
      payload: PayloadSubmitSuccessCaseExternal
    ): Promise<any> {
      const { data } = await API.postSuccessCaseExternal(payload);
      return data;
    },
  },
  modules: {},
};
